import { type ReactNode } from "react";
import Typography, { type TypographyProps } from "@mui/material/Typography";

interface DtProps extends TypographyProps {
    children: ReactNode;
}

const Dt = ({ children, ...props }: DtProps) => (
    <Typography component="dt" fontWeight="bold" {...props}>
        {children}:
    </Typography>
);

export default Dt;
